import { render, staticRenderFns } from "./startseite-software-1.vue?vue&type=template&id=df61a6be&"
import script from "./startseite-software-1.vue?vue&type=script&lang=js&"
export * from "./startseite-software-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports